module.exports = __webpack_public_path__ + "static/media/engine-oil-filters-mr-card-front.1a5d153d.jpeg";